import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import useTagList from "@/utils/hooks/useTagList";
import tagModel from "@/models/tag/tag-list";
import inventoryListModel from "@/models/inventory/inventory-list";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import surveyModel from "@/models/survey-quiz/survey";

export default function usePrivilegeTab(props) {
  const { openModal, closeModal } = useModal();

  const { fetchDetailSurveyModel, editSurveyModel } = surveyModel();

  const {
    openErrorModal,
    openDefaultErrorModal,
    openSuccessModal,
  } = useValidationModal();

  const { fetchTagList } = tagModel();

  const {
    fetchInventoryList: fetchInventoryListModel,
    fetchEntryInventoryList,
  } = inventoryListModel();

  const vm = getCurrentInstance().proxy;

  const privilegeData = reactive({
    surveyGroupId: null,
    headerName: "กรุณาตั้งค่าสิทธิ์การเข้าถึงแบบสำรวจ",
    descTag: "ได้สิทธิ์ใช้งานแบบสำรวจนี้ได้",
    descVisibility: "ที่มองเห็นแบบสำรวจนี้ได้",
    descPermission: "ที่ได้สิทธิ์ใช้งานแบบสำรวจนี้ได้",
    selected: 1,
    permissionList: [],
    visibility: [],
    permission: [],
    rewardType: 0,
    isEqual: 1,
    point: 0,
    selectInventory: "",
    selectPrivilegeData: "",
    permissionListSetting: [
      // {
      //   tagName: "",
      //   point: "0",
      //   reward: "",
      // },
    ],

    isEdit: true,
    permissionData: {
      isLimit: false,
      limit: 0,
    },
  });

  const PRIVILEGETYPE = {
    REWARDTYPE: {
      NOREWRAD: 0,
      POINT: 1,
      REWARD: 2,
    },
    EQUALTYPE: {
      EQUAL: 1,
      NOTEQUAL: 2,
    },
  };

  const tagOption = reactive({
    visibilityTagOption: [],
    permissionOption: [],
  });

  const optionData = reactive({
    inventoryList: [],
    privilegeList: [],
  });

  const modalType = reactive({
    isChangePermission: false,
    isSetPoint: false,
    isSetReward: false,
  });

  const onOpenModalSettingPoint = () => {
    modalType.isSetPoint = true;
    openModal();
  };

  const onCloseModalSettingPoint = () => {
    closeModal();
    modalType.isSetPoint = false;
  };

  const onOpenModalChangePermission = (data, index) => {
    modalType.isChangePermission = true;
    openModal();
  };

  const onCloseModalChangePermission = () => {
    closeModal();
    modalType.isChangePermission = false;
  };

  const changeOption = reactive({
    optionRewardtype: [
      { item: 0, name: "ไม่ได้รางวัล" },
      { item: 1, name: "แต้ม" },
      { item: 2, name: "ของรางวัล" },
    ],
  });

  const onUpdatePoint = (point) => {
    privilegeData.point = point || 0;
    privilegeData.selectInventory = null;
    privilegeData.selectPrivilegeData = null;

    if (privilegeData.permissionListSetting.length > 0) {
      privilegeData.permissionListSetting.map((o) => {
        o.point = point;
        o.selectPrivilege = null;
        o.selectPrivilegeName = null;
      });

      privilegeData.permissionList.map((o) => {
        o.selectPrivilege = null;
        o.selectPrivilegeName = null;
      });

      optionData.privilegeList = [];
    }
  };

  const fetchTag = () => {
    // window.$loading(true);
    store
      .dispatch("api/apiRequest", fetchTagList)
      .then((resp) => {
        if (resp.data.tag_list.length > 0) {
          tagOption.visibilityTagOption = resp.data.tag_list.map((obj) => ({
            seq: obj.seq,
            label: obj.tag,
          }));
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        // window.$loading(false);
      });
  };

  const fetchInventoryList = (inventoryId) => {
    // window.$loading(true);

    store
      .dispatch("api/apiRequest", fetchInventoryListModel)
      .then((response) => {
        optionData.inventoryList = response.data.payload.map((o) => ({
          label: o.name,
          value: o.inventory_id,
        }));

        if (inventoryId) fetchPrivilegeList(inventoryId, false);
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        // window.$loading(false);
      });
  };

  const fetchPrivilegeList = (inventoryId, isChangeInventory) => {
    fetchEntryInventoryList.payload.Inventory_Id = inventoryId;
    store
      .dispatch("api/apiRequest", fetchEntryInventoryList)
      .then((response) => {
        optionData.privilegeList = response.data.payload.map((o) => ({
          label: o.privilege.name_th,
          value: o.privilege.privilege_id,
        }));
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        // window.$loading(false);
      });
  };

  const onSelectTagVisibility = (TagVisibility) => {
    tagOption.permissionOption = TagVisibility;

    if (tagOption.permissionOption.length != privilegeData.permission.length) {
      privilegeData.permission = tagOption.permissionOption.filter((o) => {
        return privilegeData.permission.indexOf(o) > -1;
      });
    } else {
      privilegeData.permission = tagOption.permissionOption.filter((o) => {
        return privilegeData.permission.includes(o);
      });
    }
  };

  //save change permission
  const onChangePermission = (formData) => {
    window.$loading(true);

    let tagAll;

    let tagSurveyName = formData.visibility.map((nameTag) => ({
      Tag_Name: nameTag,
      Tag_Type: 1,
    }));

    let tagSurveyNamePer = formData.permission.map((nameTag) => ({
      Tag_Name: nameTag,
      Tag_Type: 2,
    }));

    tagAll = tagSurveyName.concat(tagSurveyNamePer);

    const payload = {
      Survey_GroupId: privilegeData.surveyGroupId,
      Permission: {
        Tag: tagAll,
        IsLimit: privilegeData.permissionData.isLimit,
        Limit: privilegeData.permissionData.limit,
      },
    };

    editSurveyModel.payload = payload;

    store
      .dispatch("api/apiFormRequest", editSurveyModel)
      .then((response) => {
        privilegeData.visibility = [];
        privilegeData.permission = [];

        fetchDetailSurvey();
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });

    modalType.isChangePermission = false;
  };

  const onChangePrivilege = (selectPrivilege, index) => {
    let obj = [];

    //เวลามีการเปลี่ยน privilge ให้ point เป็น 0
    if (privilegeData.permissionListSetting.length > 0) {
      privilegeData.permissionListSetting.map((o) => {
        o.point = null;
      });
    }

    privilegeData.point = null;

    obj = [...privilegeData.permissionListSetting]; //[...] clone
    obj.map((element, idx) => {
      if (index == idx) {
        element.selectPrivilege = selectPrivilege;
      }
    });
    privilegeData.permissionListSetting = obj;
  };

  //เวลามีการเปลี่ยน privilge ให้ point เป็น 0
  const onChangePrivilegeData = (selectPrivilege) => {
    privilegeData.point = null;

    if (privilegeData.permissionListSetting.length > 0) {
      privilegeData.permissionListSetting.map((o) => {
        o.selectInventory = privilegeData.selectInventory;
        o.selectPrivilege = selectPrivilege;
        o.point = null;
      });

      //แสดงตรง preview
      privilegeData.permissionList.map((o) => {
        o.selectInventory = privilegeData.selectInventory;
        o.selectPrivilege = selectPrivilege;
        o.selectPrivilegeName = o.selectPrivilegeName;
      });
    }
  };

  //เวลาเปลี่ยน inventory เคลียร์ Privilege
  const onChangeInventory = () => {
    privilegeData.selectPrivilegeData = null;

    if (privilegeData.permissionListSetting.length > 0) {
      privilegeData.permissionListSetting.map((o) => {
        o.selectPrivilege = null;
      });
    }
  };

  const onInputDuplicateTag = (isDuplicate) => {
    if (isDuplicate) {
      privilegeData.permission = privilegeData.visibility;
    } else {
      privilegeData.permission = "";
    }
  };

  //set data setting moal
  const onSubmitSettingPoint = (dataSetPoint, optionPrivilige) => {
    // set privilegeName
    dataSetPoint.permissionListSetting.map((o) => {
      let objOptionPrivilige = null;

      objOptionPrivilige = optionPrivilige.find(
        (e) => e.value == o.selectPrivilege
      );

      if (objOptionPrivilige) {
        o.selectPrivilegeName = objOptionPrivilige.label;
      }
    });

    privilegeData.permissionList = dataSetPoint.permissionListSetting;
    modalType.isSetPoint = false;
  };

  const onUpdateSettingPoint = (point, index) => {
    privilegeData.permissionListSetting.map((o, idx) => {
      if (index == idx) {
        o.point = point;
      }
    });

    // เวลามีการอัปเดรตคะแนนให้ privilege กับ inventory เป็น null
    privilegeData.selectInventory = null;
    privilegeData.selectPrivilegeData = null;

    privilegeData.permissionListSetting.map((o) => {
      privilegeData.selectInventory = null;
      o.selectPrivilege = null;
      o.selectPrivilegeName = null;
    });

    optionData.privilegeList = [];
  };

  const fetchDetailSurvey = () => {
    window.$loading(true);
    fetchDetailSurveyModel.payload.Survey_GroupId = privilegeData.surveyGroupId;

    store
      .dispatch("api/apiRequest", fetchDetailSurveyModel)
      .then((response) => {
        const responseInformation = response.data.resp.infomation;
        const responsePrivilege = response.data.resp.privilege;
        const responsePermission = response.data.resp.permission;

        privilegeData.visibility = [];
        privilegeData.permission = [];

        privilegeData.permissionData.isLimit = responseInformation.islimit;
        privilegeData.permissionData.limit = responseInformation.limit;

        privilegeData.rewardType = responseInformation.privilage_type;

        privilegeData.isEqual =
          responseInformation.criteria_type == 0
            ? 1
            : responseInformation.criteria_type;
        privilegeData.isEdit = responseInformation.isedit;

        if (responsePrivilege.length > 0) {
          //set point isEqual == 1
          privilegeData.point = responsePrivilege[0].point;
          privilegeData.surveyPrivilegeId =
            responsePrivilege[0].survey_privilegeid;

          //set ให้ inventory

          privilegeData.selectInventory = responsePrivilege[0].inventoryid;

          privilegeData.selectPrivilegeData = responsePrivilege[0].privilegeid;

          if (privilegeData.selectInventory) {
            fetchPrivilegeList(privilegeData.selectInventory, true);
          }
        }

        const filterTagId = responsePermission.filter(
          (tagData) => tagData.tagid != null && tagData.tag_type == 2
        );

        privilegeData.permissionListSetting = filterTagId.map((o) => ({
          tagName: o.tag_name,
          permissionId: o.permissionid,
          tagId: o.tagid,
          inventoryId: o.inventoryid,
        }));

        privilegeData.permissionListSetting.map((o) => {
          responsePrivilege.map((e) => {
            if (o.tagId == e.tagid) {
              o.surveyPrivilegeId = e.survey_privilegeid;
              o.selectPrivilege = e.privilegeid;
              o.point = e.point;
              o.selectPrivilegeName = e.privilege_name;
            }
          });
        });

        privilegeData.permissionList = filterTagId.map((o) => ({
          tagName: o.tag_name,
          permissionId: o.permissionid,
          tagId: o.tagid,
          inventoryId: o.inventoryid,
        }));

        privilegeData.permissionList.map((o) => {
          responsePrivilege.map((e) => {
            if (o.tagId == e.tagid) {
              o.selectPrivilege = e.privilegeid;
              o.point = e.point;
              o.selectPrivilegeName = e.privilege_name;
            }
          });
        });

        responsePermission.map((o) => {
          if (o.tag_type == 1) {
            privilegeData.visibility.push(o.tag_name);
          } else if (o.tag_type == 2) {
            privilegeData.permission.push(o.tag_name);
          }
        });

        tagOption.permissionOption = privilegeData.visibility;
      })
      .catch((err) => {
        openDefaultErrorModal(err);
      })
      .finally(() => {
        window.$loading(false);
      });
  };

  onBeforeMount(() => {
    if (router.currentRoute.query.surveyGroupId) {
      privilegeData.surveyGroupId = parseInt(
        router.currentRoute.query.surveyGroupId
      );
    } else {
      privilegeData.surveyGroupId = parseInt(router.currentRoute.params.ref);
    }

    vm.$emit("onSetPrivilegeData", privilegeData);
    fetchTag();
    fetchInventoryList();
    fetchDetailSurvey();
  });

  watch(
    privilegeData,
    () => {
      if (privilegeData.selectPrivilegeData) {
        privilegeData.point = null;
      }
    },
    { deep: true }
  );

  watch(
    privilegeData,
    () => {
      vm.$emit("onSetPrivilegeData", privilegeData);
    },
    { deep: true }
  );

  watch(
    () => props,
    () => {
      if (props?.isEdit) fetchDetailSurvey();
    },
    { deep: true }
  );

  return {
    privilegeData,
    modalType,
    changeOption,
    onOpenModalSettingPoint,
    onCloseModalSettingPoint,
    onOpenModalChangePermission,
    onCloseModalChangePermission,
    tagOption,
    onUpdatePoint,
    optionData,
    onSelectTagVisibility,
    onChangePermission,
    onInputDuplicateTag,
    onSubmitSettingPoint,
    onUpdateSettingPoint,
    fetchPrivilegeList,
    fetchInventoryList,
    onChangePrivilege,
    onChangePrivilegeData,
    onChangeInventory,
    PRIVILEGETYPE,
  };
}
